import angular from 'angular';
import ProductDetailController from "./productdetail.controller";
import ProductDetailService from "./productdetail.service";
import AddToCartService from "./addtocart.service";
import AddToCartController from "./addtocart.controller";
import EnterPickupController from "./enterpickup.controller";
import RecentlyViewedController from "./recentlyviewed.controller";
import RecentlyViewedService from "./recentlyviewed.service";
import ReviewController from './review.controller';
import InfoBoxService from './notLoggedInInfoBox.service';

let ProductDetail = angular
    .module('ProductDetail', [])
    .controller('ProductDetailController', ProductDetailController)
    .service('ProductDetailService', ProductDetailService)
    .controller('AddToCartController', AddToCartController)
    .service('AddToCartService', AddToCartService)
    .controller('EnterPickupController', EnterPickupController)
    .controller('RecentlyViewedController', RecentlyViewedController)
    .service('RecentlyViewedService', RecentlyViewedService)
    .controller('ReviewController', ReviewController)
    .service('InfoBoxService', InfoBoxService);

export default ProductDetail;
